import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

import { DataViewModel } from '../../models/DataViewModel';
import { CertificateRequest } from '../../models/certificates/CertificateRequest';
import { CertificateResponse } from '../../models/certificates/CertificateResponse';
import { CommonIdentificator } from '../../models/certificates/CommonIdentificator';

@Injectable()
export class CertificateService {
    baseUrl: string;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string,) {
        this.baseUrl = baseUrl;
    }

    public isLinkValid(linkCode: string): Observable<DataViewModel<CommonIdentificator>> {
        return this.http.get(this.baseUrl + 'api/Certificate/GetIdentificators/' + linkCode)
            .map(response => <DataViewModel<CommonIdentificator>>response)
            .catch(this.handleError);
    }

    public signCertificate(request: CertificateRequest): Observable<DataViewModel<CertificateResponse>> {
        return this.http.post(this.baseUrl + 'api/Certificate/SignCertificate', request)
            .map(response => <DataViewModel<CertificateResponse>>response)
            .catch(this.handleError);
    }

    public requestCertificate(request: CertificateRequest): Observable<DataViewModel<CertificateResponse>> {
        return this.http.post(this.baseUrl + 'api/Certificate/RequestCertificate', request)
            .map(response => <DataViewModel<CertificateResponse>>response)
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/certificates/certificate.service.ts